// src/auth/msal.ts
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID!,
    authority:
      process.env.REACT_APP_AAD_AUTHORITY ||
      `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AAD_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri:
      process.env.REACT_APP_AAD_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
} as const;

export const apiScopes = (process.env.REACT_APP_AAD_API_SCOPE || "")
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);

export const msalInstance = new PublicClientApplication(msalConfig);